import { formatDate } from "../../../utils/formatters/date";

export const formatShortDate = (iso) => formatDate(iso, "");


